export default () => [
  {
    key: "status",
    name: i18n.app.common.status
  },
  {
    key: 'license_plate',
    name: i18n.app.components.vehicle.license_plate
  },
  {
    key: 'group',
    name: i18n.app.components.vehicle.group
  },
  {
    key: 'segment',
    name: i18n.app.components.vehicle.segment
  },
  {
    key: 'brand',
    name: i18n.app.components.vehicle.brand
  },
  {
    key: 'model',
    name: i18n.app.components.vehicle.model
  },
  {
    key: 'transmission_type',
    name: i18n.app.components.vehicle.transmission_type
  },
  {
    key: 'fuel_type',
    name: i18n.app.components.vehicle.fuel_type
  },
  {
    key: 'depot',
    name: i18n.app.components.vehicle.depot
  },
  {
    key: 'client',
    name: i18n.app.components.vehicle.client
  },
];
